export enum OrderTypeEnum {
  PreOrder = 'Pre-Order',
  PreOrderMultiple = 'Pre-Order-Multiple',
  ReOrder = 'Re-Order',
  DropShip = 'Drop ship',
  ReturnOrder = 'Return',
  WarrantyOrder = 'Warranty',
  Bulks = 'Bulks',
  Replacement = 'Replacement',
  LastSeason = 'Last season',
}
